// Interfaces
import { IWrapperProps } from './interfaces'

// Styles
import styles from './index.module.scss'

const Wrapper = ({ children }: IWrapperProps) => {
  return <div className={styles.wrapper}>{children}</div>
}

export { Wrapper }
